export function handleImpersonationMessage(event: MessageEvent, win?: Window, doc?: Document) {
  const w = win || (typeof window !== 'undefined' ? window : (global as any).window);
  const d = doc || (typeof document !== 'undefined' ? document : (global as any).document);
  try {
    const data = event.data;

    const isLogout = data === 'logout' || (data && typeof data === 'object' && data.type === 'logout');
    if (!isLogout) return;

    try {
      try {
        (w as any).sessionStorage.removeItem('organizationToken');
      } catch (err) {
        // ignore storage errors
      }

      if (event.source && typeof (event.source as any).postMessage === 'function') {
        try {
          (event.source as any).postMessage({ type: 'logout-complete' }, event.origin);
        } catch (err) {
          // ignore postMessage errors
        }
      }
    } catch (err) {
      // ignore
    }
  } catch (ex) {
    // ignore
  }
}

export function installImpersonationListener(targetWindow?: Window, targetDocument?: Document) {
  const win = targetWindow || (typeof window !== 'undefined' ? window : (global as any).window);
  const doc = targetDocument || (typeof document !== 'undefined' ? document : (global as any).document);
  try {
    (win as any).addEventListener('message', (ev: MessageEvent) => handleImpersonationMessage(ev, win, doc));
  } catch (e) {
    // ignore
  }

  return () => {
    try {
      (win as any).removeEventListener('message', (ev: MessageEvent) => handleImpersonationMessage(ev, win, doc));
    } catch (e) {
      // ignore
    }
  };
}

export default installImpersonationListener;
